import { CancelAsync } from './../../app/models/cancelAsync';
import {
  Component,
  ViewChild,
  ElementRef,
  Renderer2,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Validators,
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
} from '@angular/forms';

import { Platform } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { ModalMarketingComponent, ModalIframeComponent } from '@app/modals';

import { UtilsService, ToasterService } from '@commons/services';

import {
  AppInitService,
  StatsService,
  NavigationService,
  NetworkStatusService,
  StudentService,
  ConfigUserService,
  StorageService,
} from '@app/services';

import { Student, StudentPurshasesDetails } from '@app/app.models';

import { Router } from '@angular/router';

import { environment } from './../../environments/environment';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'delete-account-page',
  templateUrl: 'delete-account.page.html',
  styleUrls: ['delete-account.page.scss'],
})
export class DeleteAccountPage extends CancelAsync {
  @ViewChild('flipBox') flipBox: any;

  pageTitle = 'Profil';
  activeLink = 'profil';
  connected: boolean = null;

  blocHeaderTitle = 'Suppression du compte';

  environment = environment;

  showLogs = true;

  callsDone = false;

  isCordova = false;

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  deleteAccountForm: UntypedFormGroup;
  formConstructed = false;

  accountJustDeleted = false;

  offToastConf = {
    text: 'Tu es hors ligne : certaines actions sont indisponibles',
    bgcolor: 'var(--color-danger)',
    duration: '5000',
  };

  genderList = [
    { name: 'Homme', value: 'm' },
    { name: 'Femme', value: 'f' },
  ];

  firstName = 'Prénom';
  lastName = 'Nom';
  cleanedPostalCode: any;
  userStatus = 'guest';
  userPicture = './uikit-assets/imgs/simone.png';
  hasPicture = false;
  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  otherChoice = false;

  student: Student;
  userLifeCycle: any;
  configUser: any;

  showFormErrors = false;

  showModal1 = false;
  closeText = "J'ai compris";

  errorMsg = '';

  displayCode = false;
  displayCodePage = false;

  displayModalDisconnect = false;

  regexEmail = '[a-zA-Z0-9._+-]{1,}@[a-zA-Z0-9._+-]{2,}[.]{1}[a-zA-Z]{2,}';
  // regexDoB = '^((0)[1-9]|[1-2][0-9]|(3)[0-1])/((0)[1-9]|(1)[0-2])/[0-9]{4}$';
  regexPhoneNumber = '^(0|\\+33)[6-7]([-. ]?[0-9]{2}){4}$';

  canSubmit = true;

  isDesktop = window.innerWidth > 767 ? true : false;

  myInterval: any;

  // FX : rotating sentences
  rotateDeg = 0;
  isBoxFx = false;
  degAddValue = this.isBoxFx ? 540 : 180;

  sentences = [
    'Extinction des feux',
    'Enclenchement du frein à main',
    'Ouverture des portières',
    'Mise au point mort',
    'Coupure du moteur',
    'Redressement du pare-soleil',
    'Rabattage des rétroviseurs',
    'Verrouillage des portières',
  ];
  sentencesBucket = JSON.parse(JSON.stringify(this.sentences));
  sentenceCpt = 0;
  sentence1 = this.sentences[this.sentenceCpt];
  sentence2: any;
  cptTours = 0;

  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;
  canZendesk = false;

  hasMadeInit = false;

  reason = '';

  statsSent = false;

  initPageDone = false;

  reasonList = [
    { name: "J'ai obtenu mon code", value: "J'ai obtenu mon code" },
    { name: "J'ai obtenu mon permis", value: "J'ai obtenu mon permis" },
    { name: "J'ai changé d'auto-école", value: "J'ai changé d'auto-école" },
    { name: "J'ai un autre compte", value: "J'ai un autre compte" },
    { name: 'Autre raison', value: 'Autre raison' },
  ];

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767 ? true : false;
  }
  @Output() hasClicked = new EventEmitter<boolean>();

  constructor(
    public navigationService: NavigationService,
    public appInitService: AppInitService,
    private statsService: StatsService,
    public router: Router,
    public platform: Platform,
    private modalController: ModalController,
    private networkService: NetworkStatusService,
    private renderer: Renderer2,
    public formBuilder: UntypedFormBuilder,
    public utils: UtilsService,
    public studentService: StudentService,
    public configUserService: ConfigUserService,
    public toasterService: ToasterService,
    public storageService: StorageService
  ) {
    super({ cancel: false, subscription: null });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    this.constructForm();

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.networkService.networkStatusObs$.subscribe(isNetworkOnline => {
      if (isNetworkOnline) {
        this.canSubmit = true;
      } else {
        this.canSubmit = false;
      }
    });

    this.isCordova = this.platform.is('cordova');
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    this.appInitService.onStepChange().subscribe(state => {
      if (state?.init >= 2 && state?.stepDone && !this.initPageDone) {
        this.initPageDone = true;
        this.initPage();
      }
      if (state?.initDone) {
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.myInterval) {
      clearInterval(this.myInterval);
    }
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  evslog(...args: any[]) {
    if (this.showLogs) {
      if (window.console) {
        console.log.apply(console, arguments);
      }
    }
  }

  async initPage() {
    // console.warn('INIT PROFIL');
    const isSignedInHard = await this.studentService.isSignedInHard();
    if (isSignedInHard) {
      this.student = this.studentService.student;
      this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
      // console.log('STUDENT FROM STORAGE', this.student);
      if (!!this.student) {
        this.firstName = !!this.student.firstName
          ? this.student.firstName
          : this.firstName;
        this.lastName = !!this.student.lastName
          ? this.student.lastName
          : this.lastName;
        this.userStatus = !!this.student.status
          ? this.student.status
          : this.userStatus;
        this.userPicture = !!this.student.picUrl
          ? this.student.picUrl
          : this.userPicture;
        this.hasPicture =
          this.userPicture === './uikit-assets/imgs/simone.png' ? false : true;
        this.cleanedPostalCode =
          !!this.student.postalCode &&
          typeof this.student.postalCode === 'string'
            ? this.student.postalCode
            : '';
        this.getPayments();
        this.callsDone = true;
      } else {
        console.error('LoginPage: NO STUDENT IN STORAGE');
        this.signOut();
      }
    } else {
      if (!this.accountJustDeleted) {
        this.openLink('login', { forceRoot: true });
      } else {
        this.callsDone = true;
      }
    }

    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink &&
      !this.statsSent
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
      this.statsSent = true;
    }

    // debug animate sentences
    // this.displayModalDisconnect = true;
    // this.sentence1 = 'Déconnexion en cours';
    // this.myInterval = setInterval(() => {
    //   this.sentenceChange();
    // }, 1500);
  }

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();
    this.canZendesk = this.studentPurshases.canZendesk();

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    this.paymentsDone = true;
  }

  get getDeleteAccountForm() {
    return this.deleteAccountForm.controls;
  }

  getAutocompleteSelectValue(form, field, value) {
    if (value === 'Autre raison') {
      this.otherChoice = true;
    }
    if (value === "J'ai obtenu mon code") {
      this.displayCode = true;
    } else {
      this.displayCode = false;
    }
    form.controls[field].patchValue(value);
  }

  constructForm() {
    this.deleteAccountForm = this.formBuilder.group({
      reason: new UntypedFormControl('', Validators.required),
      reasonText: new UntypedFormControl('', r => {
        if (this.otherChoice) {
          return Validators.compose([Validators.required]);
        }
        return null;
      }),
    });

    this.formConstructed = true;
  }

  sentenceChange(text = null) {
    this.cptTours++;
    this.rotateDeg += this.degAddValue;
    this.renderer.setStyle(
      this.flipBox.nativeElement,
      'transform',
      'translateZ(-75px) rotateX(' + this.rotateDeg + 'deg)'
    );
    if (this.sentenceCpt === this.sentences.length - 2) {
      this.sentenceCpt = 0;
    } else {
      this.sentenceCpt++;
    }
    if (this.sentencesBucket.length === 0) {
      this.sentencesBucket = JSON.parse(JSON.stringify(this.sentences));
    }
    const randomIndex = this.utils.randomMinMax(
      0,
      this.sentencesBucket.length - 1
    );
    const sentence = this.sentencesBucket[randomIndex];
    this.sentencesBucket.splice(randomIndex, 1); // remove elt from bucket
    if (this.cptTours % 2 === 0) {
      this.sentence1 = !!text ? text : sentence;
    } else {
      this.sentence2 = !!text ? text : sentence;
    }
  }

  triggerCardActionById(id) {
    if (id === 'logout') {
      if (!this.canSubmit) {
        if (this.networkService?.isOffline()) {
          this.launchToaster(this.offToastConf);
        }
      } else {
        this.signOut();
      }
    } else if (id === 'evaluate') {
      this.openLink('rating');
    } else if (id === 'modifEmail') {
      this.openLink('edit-email');
    } else if (id === 'modifPass') {
      this.openLink('edit-password');
    } else if (id === 'dossier' && this.userLifeCycle.isUserGuest) {
      this.openModalPack(
        {
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingregular',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        },
        'marketingRegular'
      );
    } else {
      this.openLink(id);
    }
  }

  submitDeleteAccountForm(values) {
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }
    const data = {
      reason: values.reason,
    };

    if (values.reason === 'Autre raison') {
      data.reason = values.reasonText;
    } else if (values.reason === "J'ai obtenu mon code") {
      this.displayCodePage = true;
      return;
    }

    this.deleteAccount(data);
  }

  deleteAccount(data) {
    this.studentService.deleteAccount(data, this.student.remoteId).subscribe(
      async () => {
        this.accountJustDeleted = true;
        this.deleteAccountForm.reset();
        this.initPage();
      },
      err => {
        if (err.status === 406) {
          // error classic
          const textMsg = JSON.stringify(err);
          this.errorMsg = JSON.parse(textMsg).error.msg;
          this.showModal1 = true;
        }
        if (err.status === 408) {
          // timeout
          this.errorMsg = `Nous n'avons pas pu supprimer ton compte, merci de réessayer plus tard`;
          this.showModal1 = true;
        }
        this.deleteAccountForm.reset();
        console.error('ProfilPage deleteAccount: ' + JSON.stringify(err));
      }
    );
  }

  hideModal1() {
    this.showModal1 = false;
  }

  launchToaster(config) {
    this.toasterService.create(config);
  }

  async setStickyToaster(value: boolean) {
    this.configUser = await this.configUserService.getUserConfig(this.student);
    if (!!this.configUser) {
      this.configUser.learningContractStickyToasterShown = !value;
    }
    this.removeStickyToaster();
    await this.configUserService.setUserConfig(this.student, this.configUser);
  }

  removeStickyToaster() {
    const toasters = document.getElementsByClassName('evs_toaster_sticky');
    while (toasters.length > 0) {
      toasters[0].parentNode.removeChild(toasters[0]);
    }
  }

  async signOut() {
    await this.setStickyToaster(false);
    this.showModalDisconnect();
    // animate sentences
    this.sentence1 = 'Déconnexion en cours';
    this.myInterval = setInterval(() => {
      this.sentenceChange();
    }, 2000);
    this.studentService
      .signOut()
      .then(() => {
        clearInterval(this.myInterval);
        this.sentenceChange('Déconnexion terminée !');
        setTimeout(() => {
          this.hideModalDisconnect();
        }, 2000);
      })
      .catch(err => {
        // Logger
        this.hideModalDisconnect();
        console.error('ProfilPage signOut: ' + JSON.stringify(err));
      });
  }

  handleClick(event) {
    if (event === 'offers') {
      this.openLink('offres');
    } else if (event === 'delete') {
      this.deleteAccount({ reason: "J'ai obtenu mon code" });
    }
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  hideModalDisconnect() {
    this.displayModalDisconnect = false;
  }

  showModalDisconnect() {
    this.displayModalDisconnect = true;
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async openLink(link, options?) {
    if (link === 'marketingRegular') {
      this.openModalPack(
        {
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingregular',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        },
        'marketingRegular'
      );
    } else if (link === 'zendesk' && !this.student.code && !this.canZendesk) {
      this.openModalPack(
        {
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingzendesk',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        },
        'marketingZendesk'
      );
    } else {
      const callbackUrl = await this.navigationService.open(link, options);
      if (!!callbackUrl && callbackUrl !== '') {
        this.openModalIframe(callbackUrl);
      }
    }
  }
}
